module.exports = __webpack_public_path__ + "static/img/20210805154814.3b09e10c.png";